<!-- 单品调仓 -->
<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div class="search-ctn">
    <div class="search-ctn-left">
        <div class="search-name">调仓仓库</div>
      <el-select
        v-model="searchData.WarehouseId"
        :loading="loading"
        class="search-item"
        size="small"
        filterable
        clearable
        remote
        @change="warehouseChange1"
      >
        <el-option
          v-for="optionItem in WarehouseList1"
          :label="optionItem.WarehouseName"
          :value="optionItem.WarehouseId"
          v-bind:key="optionItem.index"
        ></el-option>
      </el-select>
      <div class="search-name">调出仓位</div>
      <el-select
        v-model="searchData.ShelfSpaceId"
        class="search-item"
        :loading="loading"
        filterable
        clearable
        remote
        reserve-keyword
        @change="shelfSpaceChange1"
        size="small"
      >
        <el-option
          v-for="optionItem in positionList1"
          :key="optionItem.GoodsLocationId"
          :label="optionItem.GoodsLocationCode"
          :value="optionItem.GoodsLocationId"
        ></el-option>
      </el-select>
      <div class="search-name">——</div>
      <div class="search-name">调入仓位</div>
      <el-select
        v-model="subData.InGoodsLocationId"
        class="search-item"
        filterable
        clearable
        remote
        reserve-keyword
        @change="InGoodsLocationChange"
        :remote-method="searchInPosition"
        size="small"
        v-select-scroll-more="searchInPositionLoad"
        popper-class="el-select-style-gray"
      >
        <el-option
          v-for="optionItem in positionList2"
          :key="optionItem.ShelfSpaceId"
          :label="optionItem.ShelfSpaceCode"
          :value="optionItem.ShelfSpaceId"
        ></el-option>
          <el-option
            v-if="loading"
            disabled
            value
            style="text-align: center"
          >
            加载中 <i class="el-icon-loading"></i>
          </el-option>        
      </el-select>
      <el-button
        size="small"
        class="search-btn btn-primary"
        v-if="permission.saveTrans"
        :disabled="!canSubmit"
        @click="save()"
      >保存改仓单</el-button>
    </div>
    </div>
    <div class="search-ctn">
     <div class="search-ctn-left">
         <div class="search-name">调仓备注</div>
      <el-input class="search-item" size="small" style="width: 890px" v-model="subData.Remark"></el-input>
     </div>
    </div>
    <div class="section-title"><div class="sec-item">改仓商品数据清单</div></div>
    <div class="div-table-row table-title">
      <div class="div-table-cell" style="width: 20%">
        <span class="color-red">*</span>汽配编码
      </div>
      <div class="div-table-cell" style="width: 15%">
        <span class="color-red">*</span>配件名称
      </div>
      <div class="div-table-cell" style="width: 15%">车型</div>
      <div class="div-table-cell" style="width: 10%">单位</div>
      <div class="div-table-cell" style="width: 20%">存放仓库仓位</div>
      <div class="div-table-cell" style="width: 10%">仓位库存数量</div>
      <div class="div-table-cell" style="width: 10%">调出数量</div>
    </div>
    <div class="edit-ctn">
      <div class="table-main">
        <div class="div-table-row table-item" v-for="(item,index) in dataList" v-bind:key="index">
          <!--        编码            -->
          <div class="div-table-cell" style="width: 20%">
            <div>
              <el-tooltip effect="dark" :content="item.APCode" placement="top">
                <span>{{item.APCode}}</span>
              </el-tooltip>
            </div>
          </div>
          <!--        名称            -->
          <div class="div-table-cell" style="width: 15%">
            <div>
              <el-tooltip effect="dark" :content="item.GoodName" placement="top">
                <span>{{item.GoodName}}</span>
              </el-tooltip>
            </div>
          </div>
          <!--        车系            -->
          <div class="div-table-cell" style="width: 15%">
            <el-tooltip effect="dark" :content="item.AutoSerise" placement="top">
              <span>{{item.AutoSerise}}</span>
            </el-tooltip>
          </div>
          <!--        单位         -->
          <div class="div-table-cell" style="width: 10%">{{item.Unit}}</div>
          <!--      存放仓库仓位        -->
          <div class="div-table-cell" style="width: 20%">
            <el-tooltip effect="dark" :content="item.OutGoodsLocationCode" placement="top">
              <span>{{item.OutGoodsLocationCode}}</span>
            </el-tooltip>
          </div>
          <!--    仓位库存数量            -->
          <div class="div-table-cell" style="width: 10%">
            <el-tooltip effect="dark" :content="item.OriginalCount.toString()" placement="top">
              <span>{{item.OriginalCount}}</span>
            </el-tooltip>
          </div>
          <!--          调出数量          -->
          <div class="div-table-cell" style="width: 10%">
            <el-input size="small" v-model="item.Count" type="number"></el-input>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "",
  components: {
    breadcrumb
  },
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      userMsg:userMsg,
      nowWarehouseName: "",
      resData: {},
      EntpTempGoodsId: "",
      showTable: false,
      type: "",
      WarehouseIdEdit: "",
      loading: false,
      searchData: {
        EntpId: userMsg.EntpId,
        WarehouseId: "",
        ShelfSpaceId: "",
        APCode: "",
        GoodName: "",
        Limit: "999"
      },
      subData: {
        UserId: userMsg.EmployeeId,
        ToId: "", // 调拨单id
        WarehouseId: "",
        OutGoodsLocationId: "", // 调出仓位id
        InGoodsLocationId: "",
        Remark: "",
        DetailList: []
      },
      dataList: [],
      WarehouseList1: [],
      WarehouseList: [],
      positionList1: [],
      positionList2: [],
      permission: {},
      inPForm: {
        Page: 1,
        Limit: 10,
        stopLoad: false,
        key: "",
      },
     canSubmit:true,             
    };
  },
  mounted() {
    this.permission = this.$util.getPermission("warehouse");
    this.EntpTempGoodsId = this.$route.query.EntpTempGoodsId;
    this.type = this.$route.query.type;
    this.getTableData();
    this.getWarehouse();
  },
  methods: {
    // 保存调仓单
    save(gotoAdd) {
      let _list = this.dataList;
      if (!this.dataList[0]) {
        this.$util.warningMsg("请添加配件");
        return;
      }
      if (!this.searchData.WarehouseId) {
        this.$util.warningMsg("请选择仓库");
        return;
      }
      if (!this.searchData.ShelfSpaceId) {
        this.$util.warningMsg("请选择出仓仓位");
        return;
      } 
      if (!this.subData.InGoodsLocationId) {
        this.$util.warningMsg("请选择入仓仓位");
        return;
      }                  
      for (let i = 0; i < _list.length; i++) {
        if (_list[i].Count > _list[i].OriginalCount) {
          this.$util.warningMsg("调出数量不得大于库存数量");
          return;
        }
      }
      this.canSubmit=false;
      this.subData.WarehouseId = this.searchData.WarehouseId;
      this.subData.OutGoodsLocationId = this.searchData.ShelfSpaceId;
      this.subData.DetailList = this.dataList;
      this.subData.UserId = this.userMsg.EmployeeId;
      this.$util
        .axiosPost({
          url: "/api/EntpTransferOrder/SaveEnterpriseTransferOrder",
          data: this.subData,
        })
        .then(res => {
          this.$util.successMsg("改仓成功");
          if (gotoAdd) {
            this.$router.push(
              `/inventoryManage/singleTransWarehouse?EntpTempGoodsId=${this.EntpTempGoodsId}`
            );
            setTimeout(() => {
              window.location.reload();
            }, 1000);
            this.canSubmit=true;
          } else {
            setTimeout(() => {
              this.$router.push("/inventoryManage/transSpaces");
            }, 1000);
          }
        }).catch(() => {this.canSubmit=true;});
    },
    // 保存并添加调仓单
    saveAndAdd() {
      this.save(true);
    },
    // 编辑&查看时获取列表
    getTableData() {
      this.dialogVisible = false;
      this.$util
        .axiosGet({
          url: "/api/EntpTransferOrder/GetEnterprisePart",
          data: {
            EntpTempGoodsId: this.EntpTempGoodsId,
            EntpId: this.userMsg.EntpId
          }
        })
        .then(res => {
          let data = res.data;
          if (!data) data = {};
          this.resData = data.Part;
          this.WarehouseList1 = data.WarehouseList;
          this.getTableAll(data);
        });
    },
    getTableAll(data) {
      let _dataList = [];
      for (let i = 0; i < data.WarehouseList.length; i++) {
        for (
          let j = 0;
          j < data.WarehouseList[i].GoodsLocationList.length;
          j++
        ) {
          _dataList.push({
            APCode: this.resData.APCode,
            AutoSerise: this.resData.AutoSerise,
            EntpTempGoodsId: this.resData.EntpTempGoodsId,
            GoodName: this.resData.GoodName,
            Unit: this.resData.Unit,
            OriginalCount: data.WarehouseList[i].GoodsLocationList[j].Count,
            Count: data.WarehouseList[i].GoodsLocationList[j].Count,
            OutGoodsLocationCode:
              data.WarehouseList[i].WarehouseName +
              " / " +
              data.WarehouseList[i].GoodsLocationList[j].GoodsLocationCode
          });
        }
      }
      this.dataList = _dataList;
    },

    //  调出仓库改变获取仓位
    warehouseChange1(id) {
      this.dataList = [];
      this.positionList1 = [];
      this.searchData.ShelfSpaceId = "";
      for (let i = 0; i < this.WarehouseList1.length; i++) {
        if (this.WarehouseList1[i].WarehouseId == id) {
          this.nowWarehouseName = this.WarehouseList1[i].WarehouseName;
          this.positionList1 = this.WarehouseList1[i].GoodsLocationList;
        }
      }
      for (let i = 0; i < this.positionList1.length; i++) {
        this.dataList.push({
          APCode: this.resData.APCode,
          AutoSerise: this.resData.AutoSerise,
          EntpTempGoodsId: this.resData.EntpTempGoodsId,
          GoodName: this.resData.GoodName,
          Unit: this.resData.Unit,
          OriginalCount: this.positionList1[i].Count,
          Count: this.positionList1[i].Count,
          OutGoodsLocationCode:
            this.nowWarehouseName +
            " / " +
            this.positionList1[i].GoodsLocationCode
        });
      }
      this.searchInPosition('');
    },

    //  调出仓位改变
    shelfSpaceChange1(id) {
      for (let i = 0; i < this.positionList1.length; i++) {
        if (this.positionList1[i].GoodsLocationId == id) {
          this.dataList = [
            {
              APCode: this.resData.APCode,
              AutoSerise: this.resData.AutoSerise,
              EntpTempGoodsId: this.resData.EntpTempGoodsId,
              GoodName: this.resData.GoodName,
              Unit: this.resData.Unit,
              OriginalCount: this.positionList1[i].Count,
              Count: this.positionList1[i].Count,
              OutGoodsLocationCode:
                this.nowWarehouseName +
                " / " +
                this.positionList1[i].GoodsLocationCode
            }
          ];
        }
      }
    },


    // 调入仓位发生改变
    InGoodsLocationChange(value) {
      if (value == this.searchData.ShelfSpaceId) {
        this.subData.InGoodsLocationId = "";
        this.$util.warningMsg("调入仓位和调出仓位不能相同");
      }
    },
    searchInPositionLoad() {
      this.inPForm.Page += 1;
      this.searchInPosition();
    },  
    // 调入仓库发生改变时搜仓位
    searchInPosition(key) {
      if(!this.searchData.WarehouseId){
        this.$util.warningMsg("请选择仓位");
        return;
      }      
      if (![undefined].includes(key)) {
        this.inPForm.Page = 1;
        this.inPForm.stopLoad = false;
        this.inPForm.key = key;
        this.positionList2 = [];
      }
      if (this.inPForm.stopLoad) return;        
      this.loading = true;
      this.$util
        .GetShelfSpacesList({
            WarehouseId: this.searchData.WarehouseId,
            ShelfSpaceCode: this.inPForm.key,
            IsLimit:true,
            Page:this.inPForm.Page,
            Limit: this.inPForm.Limit,
        })
        .then((res) => {
          let data = res.data;
          this.loading = false;
          if (data&&data.length > 0) {
            this.subData.InGoodsLocationId = "";
            this.inPForm.stopLoad = data.length < this.inPForm.Limit;
            this.positionList2 = [...this.positionList2, ...data];   
          } else {
            this.$util.warningMsg("该仓库暂无该编号仓位");
          }
        });
    },

    // 获取仓库列表
    getWarehouse() {
       this.$util.getWarehouse().then((data) => {
        this.WarehouseList = data;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.search-ctn {
  min-height: 0px;
}
.form-main {
  display: flex;
  > div {
    width: 33.33%;
  }
}
.form-section {
  display: flex;
}
.section-title {
  display: flex;
  justify-content: space-between;
  height: 36px;
  line-height: 36px;
  padding: 0 20px;
  font-weight: bold;
  font-size: @font-sm;
  margin-left: -1px;
  background: @border3Color;
}
.edit-ctn {
  .div-table-cell {
    padding: 0 5px;
  }
}
.option-content {
  display: flex;
  line-height: 30px;
}
.add-btn {
  position: absolute;
  right: -42px;
  bottom: -40px;
  height: 40px;
  width: 40px;
}
.less-btn {
  position: absolute;
  right: -42px;
  top: 5px;
  z-index: 2;
  height: 40px;
  width: 40px;
}
.table-main {
  position: relative;
}
.image-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border: 1px dashed @border3Color;
}
.table-title {
  line-height: 36px;
  text-align: center;
  font-weight: bold;
}
.div-table-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.table-item {
  height: 36px;
  position: relative;
}
.div-table-row {
  overflow: inherit;
}
.history-main {
  position: absolute;
  left: 0;
  width: 100%;
  height: 140px;
  overflow: auto;
  padding: 10px;
  border: 1px solid @border3Color;
  background: white;
  z-index: 2;
  .history-row {
    display: flex;
    align-items: center;
    cursor: pointer;
    &:hover {
      background: @border3Color;
    }
    > div {
      text-align: center;
      line-height: 30px;
    }
  }
}
.history-no-data {
  text-align: center;
  font-size: 26px;
  line-height: 100px;
}
</style>
